var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"manyTable"},[_c('Table',{staticClass:"tablecolor",attrs:{"border":"","columns":_vm.columns,"show-header":false,"data":_vm.row}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }